//import { Tab } from 'bootstrap/dist/js/bootstrap.esm.min.js'

import "../styles/app.scss"
import { Menu } from './inc/menu.js'
import { Hamburger } from './inc/hamburger.js'
import { Tabs } from './inc/Tabs/tabs.js'
import { SliCollapse } from './inc/Collapse/collapse.js'

new Menu( '.explore' , '#nav-explore' )
new Tabs( '.tabs-nav' , '.tabs-section' )
new SliCollapse()
new Hamburger()


(function(){
    console.log( "oo" )
})